
import { defineComponent, PropType } from 'vue'
import { iCategory, iTargetDefinition } from './TargetDefinition'
import AutoComplete from 'primevue/autocomplete'
import Calendar from 'primevue/calendar'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'

export default defineComponent({
    name: 'target-definition-form',
    components: {
        AutoComplete,
        Calendar,
        KnValidationMessages
    },
    props: {
        selectedTarget: {
            type: Object as PropType<iTargetDefinition>
        },
        categories: {
            type: Array
        },
        vcomp: Object
    },
    emits: ['touched', 'valueChanged'],
    watch: {
        selectedTarget() {
            this.target = { ...this.selectedTarget }
        },
        categories() {
            this.loadCategories()
        }
    },
    data() {
        return {
            target: {} as iTargetDefinition,
            filteredCategory: [] as iCategory[]
        }
    },
    created() {
        this.loadCategories()
    },
    methods: {
        loadCategories() {
            this.filteredCategory = [...(this.categories as iCategory[])]
        },
        valueChanged(fieldName: string, value: any) {
            this.$emit('valueChanged', { fieldName, value })
        },
        searchCategory(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.filteredCategory = [...(this.categories as iCategory[])]
                } else {
                    this.filteredCategory = this.categories?.filter((category: any) => {
                        return category.valueName && category.valueName.toLowerCase().startsWith(event.query.toLowerCase())
                    }) as iCategory[]
                }
            }, 250)
        }
    }
})
